const bodyOverlayVisible = 'body--overlay-visible';
const overlayVisible = 'overlay--visible';

// Overlays
const formtypes = ['login', 'partner', 'signup', 'badumbau', 'hausnotruf'];
formtypes.forEach((formtype) => {
  const openButton = document.querySelectorAll(`.js-overlay-${formtype}, a[target="${formtype}form"]`);
  const overlay = document.querySelector(`.overlay--${formtype}`);
  if (openButton && overlay) {
    const { body } = document;
    const closeButton = overlay.querySelector('.overlay__close');
    const overlayBody = overlay.querySelector('.overlay__body');

    // Open
    const openOverlay = (event) => {
      event.preventDefault();
      const allOverlays = document.querySelectorAll('.overlay');
      allOverlays.forEach((item) => {
        item.classList.remove(overlayVisible);
      });

      document.querySelector('.overlay').classList.remove(overlayVisible);
      overlay.classList.add(overlayVisible);
      body.classList.add(bodyOverlayVisible);
      event.stopPropagation();
      return false;
    };
    openButton.forEach(button => button.addEventListener('click', openOverlay));
    // Close
    const closeOverlay = () => {
      overlay.classList.remove(overlayVisible);
      body.classList.remove(bodyOverlayVisible);
    };
    closeButton.addEventListener('click', closeOverlay);
    // Click outside
    const clickOutsideOverlay = (event) => {
      const isClickInside = overlayBody.contains(event.target);
      if (!isClickInside) {
        overlay.classList.remove(overlayVisible);
        body.classList.remove(bodyOverlayVisible);
      }
    };
    document.addEventListener('click', clickOutsideOverlay);
  }
});
